import React from 'react';
import {Button, Typography} from "@mui/material";
import {HomeStyle} from "../../../../../styles/pages/home/HomeStyle";
import {useHistory} from "react-router-dom";

const events = [
	{
		time: "09:30",
		title: "Allineamento operativo",
		subtitle: "Sala G. Garibaldi",
		color: "#4285F4",
	},
	{
		time: "12:00",
		title: "Revisione pratiche",
		subtitle: "Ufficio N. Bonaparte",
		color: "#FBBC05",
	},
];

export const EventiPaper = () => {
	const classes = HomeStyle();
	const history = useHistory();

	return (
		<section className={classes.card}>
			<header className={classes.cardHeader}>
				<div>
					<Typography className={classes.cardTitle}>Agenda</Typography>
					<Typography className={classes.cardSubtitle}>
						Una vista compatta degli appuntamenti della giornata.
					</Typography>
				</div>
			</header>

			<div className={classes.eventList}>
				{events.map((event) => (
					<div className={classes.eventItem} key={`${event.time}-${event.title}`}>
						<div className={classes.eventTime} style={{"--event-color": event.color}}>
							{event.time}
						</div>
						<div>
							<Typography className={classes.eventTitle}>{event.title}</Typography>
							<Typography className={classes.eventSubtitle}>{event.subtitle}</Typography>
						</div>
					</div>
				))}
			</div>

			<div className={classes.cardFooter}>
				<Button variant="outlined" onClick={() => history.push("/v2/gestione/eventi")} disabled>
					Visualizza agenda
				</Button>
			</div>
		</section>
	);
};
